import store from '@/store';
import randomColor from '@/shared/utils/random-color';
import { newEvent } from '@/shared/utils/notification-title';
import { EventBus } from '@/event-bus.js';
import {
  ADD_MESSAGE_STATUS,
  ADD_CURRENT_PROTOCOL,
  SET_JOB_CHANNEL,
} from '@/store/mutation-types.js';

export default class NewVoiceEvent {
  constructor(body) {
    store.commit('voice/RESET_VOICE_STATUS');
    delete body.messageStatus;

    if (body.callType === 'MANUAL') {
      body.messageStatus = 'progress';
      const activeJob = store.getters['jobs/activeJob'];

      store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'isService');
      store.commit(`voice/${ADD_CURRENT_PROTOCOL}`, activeJob);
      const job = store.state.jobs.jobList.find((job) => {
        if (job) {
          return job.protocol === body.protocol;
        }
      });
      if (job) return;
    } else if (body.callType === 'QUEUE' || body.callType === 'DIALER') {
      body.messageStatus = 'isService';
      store.commit(`voice/${ADD_MESSAGE_STATUS}`, 'isService');
    } else {
      body.messageStatus = 'isService';
    }

    const styleLog =
      'color: #3949AB; font-weight: bold; background-color: #FFF59D;';
    console.group('%c NewVoiceEvent: ', styleLog);
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));

    body.color = randomColor();
    body.channel = 'voice';
    body.disabled = body?.closedWithoutQualify || false;
    body.history = [];
    body.tab = {
      active: 0,
      tab: 'script',
    };

    body.observation = body.observation || '';

    if (body.observation) {
      store.dispatch('observation/newObservation', {
        observation: body.observation,
        protocol: body.protocol,
      });
    }

    if (body.transfer) {
      store.dispatch('dialogs/closeDialogTransferCallReceived');
    }
    EventBus.$emit('close-toggle-infobars');
    EventBus.$emit('close-select-qualification-dialog');
    store.dispatch('jobs/newVoice', body);
    store.commit(`jobs/${SET_JOB_CHANNEL}`, 'voice');
    store.commit('voice/ADD_MESSAGE_STATUS', 'progress');
    newEvent();
  }
}
